import { AppError } from './AppError'

export class AbortError extends AppError {
  constructor(message: string = 'Aborted') {
    super({ message })
  }
}
